enum BlockType {
	SPECIALTY = 'SPECIALTY',
	SURGEON = 'SURGEON',
	GROUP = 'GROUP',
}

export default BlockType;
